<template>
  <div class="container" id="home">
    <h2>問題数</h2>
    <form action="#" class="flex">
      <p>
        <label>
          <input
            class="with-gap"
            name="group1"
            type="radio"
            @click="setLength(10)"
            checked
          />
          <span>10</span>
        </label>
      </p>
      <!-- <p>
        <label>
          <input class="with-gap" name="group1" type="radio" @click="setLength(20)" />
          <span>20</span>
        </label>
      </p>
      <p>
        <label>
          <input class="with-gap" name="group1" type="radio" @click="setLength(30)" />
          <span>30</span>
        </label>
      </p>-->
    </form>
    <h2>難易度</h2>
    <!-- <form action="#">
      <p>
        <label>
          <input class="with-gap" name="group1" type="radio" @click="setLevel(1)" checked />
          <span>初級（30/40/50符）</span>
        </label>
      </p>
      <p>
        <label>
          <input class="with-gap" name="group1" type="radio" @click="setLevel(2)" />
          <span>中級（20/25/30/40/50符）</span>
        </label>
      </p>
      <p>
        <label>
          <input class="with-gap" name="group1" type="radio" @click="setLevel(3)" />
          <span>
            上級 親子・ロンツモ
            <b>混合</b>
            <br />（20/25/30/40/50/70符）
          </span>
        </label>
      </p>
    </form>-->
    <div class="radio">
      <input
        type="radio"
        name="level"
        id="level1"
        @click="setLevel(1)"
        checked
      />
      <label for="level1">
        <span class="level-name">初級</span>
        <br />30/40/50符
      </label>
      <input type="radio" name="level" id="level2" @click="setLevel(2)" />
      <label for="level2">
        <span class="level-name">中級</span>
        <br />20/25/30/40/50符
      </label>
      <input type="radio" name="level" id="level3" @click="setLevel(3)" />
      <label for="level3">
        <span class="level-name">上級</span>
        <br />20/25/30/40/50/70符
      </label>
    </div>
    <p class="desc-right">※「上級」は親子・ロンツモ 混合</p>
    <h2>子・親</h2>
    <!-- <form action="#" class="flex">
      <p>
        <label>
          <input
            class="with-gap"
            name="group1"
            type="radio"
            @click="setKo(1)"
            :disabled="level === 3 ? true : false"
            checked
          />
          <span>子</span>
        </label>
      </p>
      <p>
        <label>
          <input
            class="with-gap"
            name="group1"
            type="radio"
            @click="setKo(2)"
            :disabled="level === 3 ? true : false"
          />
          <span>親</span>
        </label>
      </p>
    </form>-->
    <div class="radio">
      <input
        type="radio"
        name="ko"
        id="ko1"
        @click="setKo(1)"
        :disabled="level === 3 ? true : false"
        checked
      />
      <label for="ko1">子</label>
      <input
        type="radio"
        name="ko"
        id="ko2"
        @click="setKo(2)"
        :disabled="level === 3 ? true : false"
      />
      <label for="ko2">親</label>
    </div>
    <h2>アガりかた</h2>
    <!-- <form action="#" class="flex">
      <p>
        <label>
          <input
            class="with-gap"
            name="group1"
            type="radio"
            @click="setAgari(1)"
            :disabled="level === 3 ? true : false"
            checked
          />
          <span>ロン</span>
        </label>
      </p>
      <p>
        <label>
          <input
            class="with-gap"
            name="group1"
            type="radio"
            @click="setAgari(2)"
            :disabled="level === 3 ? true : false"
          />
          <span>ツモ</span>
        </label>
      </p>
    </form>-->
    <div class="radio">
      <input
        type="radio"
        name="agari"
        id="agari1"
        @click="setAgari(1)"
        :disabled="level === 3 ? true : false"
        checked
      />
      <label for="agari1">ロン</label>
      <input
        type="radio"
        name="agari"
        id="agari2"
        @click="setAgari(2)"
        :disabled="level === 3 ? true : false"
      />
      <label for="agari2">ツモ</label>
    </div>
    <div class="flex">
      <a
        class="waves-effect waves-light btn grey lighten-1"
        href="https://casinoconcierge.cc/mahjongscore-how-to-learn#pt01"
        target="_blank"
        rel="noopener noreferrer"
        >点数表</a
      >
      <a
        class="waves-effect waves-light btn grey lighten-1"
        href="https://casinoconcierge.cc/mahjongscore-how-to-learn#pt04-2"
        target="_blank"
        rel="noopener noreferrer"
        >ゴロ合わせ</a
      >
      <a
        class="waves-effect waves-light btn grey lighten-1"
        @click="switchModal"
        >覚えるコツ</a
      >
    </div>
    <a class="waves-effect waves-light btn btn-start" @click="goDrill"
      >はじめる</a
    >
    <div class="p-modal" v-if="modalOpen">
      <h2>覚え方のコツ</h2>
      <h3>倍ずつ増えていく</h3>
      （例） <br />30符 1000→2000→3900→8000 <br />40符 1300→2600→5200
      <br />
      <h3>
        符が倍になるものは
        <br />数の並びが同じ
      </h3>
      20符と40符 <br />25符と50符 <br />30符と60符
      <br />
      <h3>
        親のツモ点数
        <br />＝子が親に請求する点数
      </h3>
      （例）40符3翻ツモ <br />親の申告：2600オール <br />子の申告：1300 / 2600
      <br />
      <a class="waves-effect waves-light btn grey darken-3" @click="switchModal"
        >閉じる</a
      >
    </div>
    <div id="overlay" @click="switchModal" v-if="modalOpen"></div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      level: 1,
      length: 10,
      ko: 1,
      agari: 1,
      modalOpen: false,
    };
  },
  methods: {
    setLevel(num) {
      this.level = num;
      if (num == 3) {
        this.ko = 3;
        this.agari = 3;
      }
      console.log(this.level);
    },
    setLength(num) {
      this.length = num;
    },
    setKo(ko) {
      this.ko = ko;
    },
    setAgari(num) {
      this.agari = num;
    },
    goDrill() {
      this.$router.push({
        name: "drill",
        query: {
          level: this.level,
          length: this.length,
          ko: this.ko,
          agari: this.agari,
        },
      });
    },
    switchModal() {
      this.modalOpen = !this.modalOpen;
    },
  },
  mounted() {
    //表示後にやりたいことはここに書ける
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/style.scss";

h2 {
  margin-top: 20px;
}
span {
  text-align: left;
}
label {
  margin-left: 6px;
}
[type="radio"]:not(:checked) + span,
[type="radio"]:checked + span {
  padding-left: 26px;
}
form {
  width: 100%;
}
form.flex {
  display: flex;
}
form p {
  text-align: left;
  margin-left: 0px;
  /* width: 100%; */
}
form.flex p {
  margin: 0;
}
.btn {
  margin-top: 20px;
  width: 50%;
  height: 52px;
  line-height: 52px;
  font-size: 18px;
}
div.flex {
  display: flex;
  justify-content: space-between;
}
.flex a {
  width: 31%;
  color: #fff;
  font-size: 16px;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 70px;
}
.btn-start {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  border-radius: 0;
  color: #fff;
  background-color: $theme-color;
}
/* モーダル */
.p-modal {
  position: fixed;
  top: 50px;
  right: 50px;
  bottom: 80px;
  left: 50px;
  overflow-y: auto;
  z-index: 99;
  background-color: #fff4f4;
  text-align: left;
  padding: 16px;
  border-radius: 6px;
}
.p-modal.is-open {
  visibility: visible;
  opacity: 1;
  z-index: 100;
}
.p-modal h2 {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}
.p-modal h3 {
  margin: 16px 0;
  font-size: 22px;
}
.p-modal .btn {
  display: inherit;
  min-width: 160px;
  margin: 34px auto;
}
#overlay {
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
/* radio */
.radio {
  display: flex;
  height: 52px;
  vertical-align: middle;
}
[type="radio"]:checked + span:after,
[type="radio"].with-gap:checked + span:after {
  background-color: $theme-color;
}
[type="radio"]:checked + span:after,
[type="radio"].with-gap:checked + span:before,
[type="radio"].with-gap:checked + span:after {
  border: 2px solid $theme-color;
}
.radio input {
  display: none;
}
.radio input + label {
  width: 100%;
  font-size: 16px;
}
.radio input[type="radio"] + label {
  background-color: #bdc3c7;
  color: #869198;
  margin: 0;
  padding: 8px 0;
  line-height: 36px;
  vertical-align: middle;
  /* font-size: 16px; */
}
.radio input[type="radio"] + label:first-of-type {
  border-radius: 4px 0 0 4px;
}
.radio input[type="radio"] + label:last-of-type {
  border-radius: 0 4px 4px 0;
}
.radio input[type="radio"]:checked + label {
  background-color: $theme-color;
  color: #fff;
}
.radio input[type="radio"]:disabled + label {
  background-color: #bdc3c7;
  color: #869198;
}
.radio input[name="level"] + label {
  font-size: 11px;
  line-height: 18px;
}
.radio input[name="level"] + label .level-name {
  font-size: 20px;
}
.desc-right {
  text-align: right;
  font-size: 12px;
}
</style>
